import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data/slate";

const Faq = () => (
    <section
        id="faq"
        data-testid="faq-section"
        className="border-b border-border bg-card"
    >
        <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-32">
            <div className="grid gap-16 md:grid-cols-12">
                <div className="md:col-span-4">
                    <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground">
                        Frequently asked
                    </p>
                    <h2 className="mt-6 font-serif text-4xl font-medium leading-[1.05] tracking-tight md:text-5xl">
                        Questions
                        <br />
                        <span className="italic">senior leaders </span>
                        actually ask.
                    </h2>
                </div>

                <div className="md:col-span-8">
                    <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
                        {FAQS.map((faq, i) => (
                            <AccordionItem
                                key={faq.q}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border-b border-border"
                            >
                                <AccordionTrigger className="py-6 text-left font-serif text-xl font-medium tracking-tight hover:no-underline md:text-2xl">
                                    {faq.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-8 text-base text-muted-foreground">
                                    {faq.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </div>
    </section>
);

export default Faq;
